export const collectibleKinds = [
    'mercer-sphere',
    'somersloop',
    'power-slug-blue',
    'power-slug-yellow',
    'power-slug-purple',
    'crash-site',
];
export const resourceNodeKinds = [
    'resource-node',
    'resource-well-core',
    'resource-well-satellite',
    'geyser',
];
export const analysisMapPointKinds = [
    'power-consumer',
    'power-generator',
    'factory-machine',
    'train-station',
    'vehicle',
];
export const overlayKinds = ['map-marker', ...analysisMapPointKinds];
export const resourceUsageStates = ['used', 'unused', 'unknown'];
export const resourceTypes = [
    'iron-ore',
    'copper-ore',
    'limestone',
    'coal',
    'caterium-ore',
    'raw-quartz',
    'sulfur',
    'uranium',
    'bauxite',
    'sam',
    'crude-oil',
    'water',
    'nitrogen-gas',
    'geyser',
];
export const resourcePurities = ['impure', 'normal', 'pure'];
export const importStates = [
    'idle',
    'checking',
    'downloading',
    'parsing',
    'ready',
    'error',
];
//# sourceMappingURL=types.js.map